<script lang="ts">
    import { Page, Block } from 'framework7-svelte';
    import { _ } from "svelte-i18n";
    
    import Header from '../components/Header.svelte';
    import { user } from '../auth/user';
    import { login, logout } from '../utils/credentials';

    function capitalize(word: string) {
        return word?.charAt(0).toUpperCase() + word?.slice(1);
    }

    const name = `${capitalize($user?.profile.given_name)} ${capitalize($user?.profile.family_name)}`;
</script>

<Page>
    <Header />

    <Block>
        {#if $user}
            <!-- @TODO: get name from keycloak in user profile -->
            <p on:click={() => logout()}>
                {$_("pages.account.WELCOME", { values: { name: name || $user.profile.preferred_username } })}
            </p>
        {:else}
            <p on:click={() => login()}>
                {$_("pages.account.NOT_LOGGED_IN")}
            </p>
        {/if}
    </Block>
</Page>
